/**
 * Maximum distance threshold for displaying nearby items
 * If the closest item is less than this distance, only items within this range are shown
 */
export const NEARBY_DISTANCE_THRESHOLD = 1000; // meters

/**
 * Gets the maximum distance to show based on filtering logic
 */
export const getMaxDisplayDistance = (minDistance: number): number => {
  return minDistance < NEARBY_DISTANCE_THRESHOLD ? NEARBY_DISTANCE_THRESHOLD : Infinity;
};
